import { render, staticRenderFns } from "./CampaignDetailHeader.vue?vue&type=template&id=604c2a77&scoped=true"
import script from "./CampaignDetailHeader.vue?vue&type=script&lang=js"
export * from "./CampaignDetailHeader.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=604c2a77&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c2a77",
  null
  
)

export default component.exports